export default import.meta.ROLLUP_FILE_URL_DlGm0x3M;